// extracted by mini-css-extract-plugin
export default {"bgStyle":"NavBar_bgStyle__ogf3y"};